export default __webpack_public_path__ + "static/media/Tatabanya.fde85334.png";